<!--@description 首页
    @author cc
    @date 2020-3-12
  -->
<template>
  <cc-container>
    <skeleton v-show="showSkeleton" />
    <div class="main" v-show="!showSkeleton">
      <cc-pull-refresh
        :disabled="disabled"
        v-model="isLoading"
        @refresh="onRefresh"
        class="pull-refresh"
      >
        <cc-container  class="home" style="height:100%;">
          <input type="hidden" value="1" id="is_home_page" />
          <cc-header-nav>
            <!-- 扫一扫 -->
            <cc-svg-icon
              @click="openScanning"
              icon-class="scan2"
              class-name="left-arrow"
              slot="left"
              size=".2rem"
            ></cc-svg-icon>
            <!-- 搜索 -->
            <div class="search-box" slot="center">
              <input
                type="text"
                placeholder="请输入通用名/商品名/厂家"
                class="input-search"
                @click="search()"
              />
              <cc-svg-icon
                size=".16rem"
                @click="search"
                class-name="search-icon-main"
                icon-class="search"
              ></cc-svg-icon>
            </div>
            <!-- 通知信息 -->
            <!-- <cc-svg-icon icon-class="notice-news" slot="right" size=".2rem"></cc-svg-icon> -->
          </cc-header-nav>

          <cc-main style="background-color:#F2F2F2;position: relative;" ref="main">
            <div>
              <div class="gradualChange"></div>
              <!-- 轮播图 -->
              <div class="swipe" v-if="swipelist.length">
                <swiper ref="mySwiper" :options="barnnswiper">
                  <swiper-slide v-for="(item,index) in swipelist" :key="index">
                    <a :href="item.url==''?'javascript:void(0);':item.url">
                      <img style="height:1.4rem;width:3.55rem;" :src="item.image" />
                    </a>
                  </swiper-slide>
                  <div style="bottom:3px;" class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
              <div class="swipe" v-else>
                <a href="javascript:void(0)">
                  <img
                    style="height:1.4rem;width:3.55rem;position:relative"
                    src="./../../assets/img/kgbg_one.png"
                  />
                </a>
              </div>
              <div class="c-column" v-if="column.length>0">
                <!-- 不需要自动轮播 -->
                <swiper ref="mySwiper" :options="swipernav">
                  <swiper-slide v-for="(item,index) in column" :key="index">
                    <div v-for="(ele,ind) in item" :key="ind">
                      <a :href="ele.href_url">
                        <span
                          v-if="ele.image"
                          :style="{background:'url('+ele.image+') no-repeat',backgroundSize:'.4rem .4rem'}"
                        ></span>
                        <span
                          style="width:.4rem;height:.4rem"
                          v-else
                          :class="ele.style_setting_arr"
                        ></span>
                        <p>{{ele.name}}</p>
                      </a>
                    </div>
                  </swiper-slide>
                  <div v-if="column.length>1" style="bottom:0px;" class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
              <!-- <div id="app-index" v-if="notificationList.length>0"> -->
                <div class="xpt-notification flex-r" style="border-radius:5px;" v-if="notificationList.length>0">
                  <div class="xpt-notification__left">
                    <img
                      src="./../../assets/img/home/shangchengkuaixun@2x.png"
                      style="display: inline-block;width: .55rem;height: .14rem;"
                      alt
                      srcset
                    />
                  </div>
                  <!-- 新闻数据开始 -->
                  <div
                    @click="$router.push({ path: '/news' })"
                    class="flex-1 xpt-notification__right"
                  >
                    <span class="fr">更多</span>
                    <div class="xpt-notification__titles">
                      <ul ref="titles">
                        <van-swipe
                          style="height: 30px;"
                          :autoplay="3000"
                          :show-indicators="false"
                          vertical
                        >
                          <van-swipe-item v-for="(item, index) in notificationList" :key="index">
                            <li v-html="item.title"></li>
                          </van-swipe-item>
                        </van-swipe>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- 新闻数据结束 -->
                <div v-if="activityindexshow.length > 0" class="image-text-area">
                  <ul style="overflow: hidden;border-radius: 4px;">
                    <li v-for="(item,index) in activityindexshow" :key="index">
                      <a @click="to(item.url)" class="image-text">
                        <img v-lazy="item.image" alt class="vt magnify" />
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- 新闻下方数据结束 -->
                <!-- 限时秒杀开始 -->
                <xpt-block
                  :more-style="{ color: '#F36732'}"
                  v-if="seckillList.length"
                  more="/#/seckill"
                >
                  <div slot="title" class="tc">
                    <img
                      src="./../../assets/img/home/shandianred@2x.png"
                      style="width: .1rem;top:0"
                      alt
                    />
                    <img src="./../../assets/img/home/xianshimiaosha@2x.png" alt />
                    <img
                      src="./../../assets/img/home/shandianpink@2x.png"
                      style="width: .1rem;top:0"
                      alt
                    />
                  </div>
                  <div class="xpt-miaosha">
                    <div class="countdown-time-box xpt-miaosha-seckill">
                      <span class="being-mad-at">{{seckillStar}}点场正在疯抢</span>
                      <span>距结束：</span>
                      <div class="inline _time" data-lave="false" data-long="true">
                      <b>{{seckillTime.countDown.h}}</b>
                      <span>时</span>
                      <b>{{seckillTime.countDown.m}}</b>
                      <span>分</span>
                      <b>{{seckillTime.countDown.s}}</b>
                      <span>秒</span>
                    </div>
                  </div>

                    <div class="xpt-product__warpper">
                      <div class="xpt-products flex-r">
                        <div
                          class="xpt-product__vertical flex-r"
                          v-for="(item, index) in seckillList"
                          :key="index"
                          style="border:0;"
                        >
                          <div class="xpt-product__desc" @click="to(item)" style="margin-top:0;">
                            <div class="xpt-product__img h88">
                              <img v-lazy="item.image" alt />
                              <!-- 已被抢光-->
                              <!-- 总库存和活动库存为0时，则为已抢光 -->
                              <div
                                v-if="getGoodsType(item)===3"
                                class="sellOut"
                              >已抢光</div>
                              <div
                                v-if="getGoodsType(item)===2"
                                class="sellOut"
                              >缺货</div>
                            </div>
                            <div class="xpt-product__desc" style="margin-bottom: 0;">
                              <div class="xpt-product__title">
                                <span class="mr5">{{item.general_name}}</span>
                                <span>{{item.norms}}</span>
                              </div>
                              <!-- 后台系统设置-商品属性展示开关控制-->
                              <div v-if="item.showproduce_unit" class="xpt-product__line">
                                <span class="ell1" v-html="item.produce_unit"></span>
                              </div>
                              <div v-if="item.showbatch_code " class="xpt-product__line">
                                <span class="ell1" v-html="item.batch_code"></span>
                              </div>
                              <div v-if="item.showsource_area" class="xpt-product__line">
                                <span class="ell1" v-html="item.source_area"></span>
                              </div>
                            </div>
                          </div>
                          <div class="xpt-product__line">
                            <div class="xpt-product__price flex-c">
                              <div class="curr-price js-pei_song_jia">
                                <span
                                  v-if="!getLoginStatus.data.member_id"
                                  class="float-load f15"
                                  v-html="'会员可见'"
                                ></span>
                                <template v-else>
                                  <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                                  <span
                                    class="float-load"
                                    :class="isNaN(item.jiage)?'f15':'f18'"
                                    v-html="item.jiage"
                                  ></span>
                                </template>
                                <cart-btn
                                  class="fr"
                                  :btn-type="getGoodsType(item)"
                                  @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                                </cart-btn>
                              </div>
                              <span class="del-price js-pei_song_jia" v-if="getLoginStatus.data.member_id == 1">
                                <del v-if="!isNaN(item.shanchu_price)">
                                  <span class="f12">￥</span>
                                  <span class="float-load" v-html="item.shanchu_price"></span>
                                </del>
                              </span>
                            </div>
                            <div class="xpt-seckill-progress flex-r">
                              <div v-if="!getLoginStatus.data.member_id" class="xpt-seckill-progress">会员可见</div>
                              <div v-else class="flex-r">
                                <div class="progress-bg">
                                  <p class="xpt-seckill-num" :style="{width:item.sale_percent+'%'}"></p>
                                </div>
                                <p class="xpt-seckill-robbed">已抢{{item.sale_percent}}%</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </xpt-block>
                <!-- 限时秒杀结束 -->

                <!-- 今日特价开始 -->
                <xpt-block
                  :more-style="{ color: '#F02E89'}"
                  v-if="special.length"
                  more="/#/special"
                >
                  <div slot="title" class="tc">
                    <img src="./../../assets/img/home/yaoping@2x.png" alt />
                    <img src="./../../assets/img/home/jinritejia @2x.png" alt />
                    <img src="./../../assets/img/home/aixin@2x.png" alt />
                  </div>
                  <div class="xpt-product__warpper xpt-special">
                    <div class="xpt-products flex-r">
                      <div
                        class="xpt-product__vertical flex-r"
                        v-for="(item, index) in special"
                        :key="index"
                      >
                        <!-- 倒计时 -->
                        <div class="countDown">
                          <p>剩</p>
                        <p v-if="+item.countDown.d">{{item.countDown.d+'天'}}</p>
                        <p v-else>{{item.countDown.h+':'+item.countDown.m+':'+item.countDown.s}}</p>
                        </div>
                        <div class="xpt-product__desc" @click="to(item)">
                          <div class="xpt-product__img h88">
                            <img v-lazy="item.image" alt />
                            <!-- 已被抢光-->
                            <div
                              v-if="getGoodsType(item)===3"
                              class="sellOut"
                            >已抢光</div>
                            <div
                              v-else-if="getGoodsType(item)===2"
                              class="sellOut"
                            >缺货</div>
                          </div>
                          <div class="xpt-product__desc" style="margin-bottom: 0;">
                            <div class="xpt-product__title">
                              <span class="mr5">{{item.general_name}}</span>
                              <span>{{item.norms}}</span>
                            </div>
                            <div v-if="item.showproduce_unit " class="xpt-product__line">
                              <span class="ell1" v-html="item.produce_unit"></span>
                            </div>
                            <div v-if="item.showbatch_code " class="xpt-product__line">
                              <span class="ell1" v-html="item.batch_code"></span>
                            </div>
                            <div v-if="item.showsource_area" class="xpt-product__line">
                              <span class="ell1" v-html="item.source_area"></span>
                            </div>
                          </div>
                        </div>
                        <div class="xpt-product__line">
                          <div class="xpt-product__price flex-c">
                            <div class="curr-price js-pei_song_jia">
                              <span v-if="!getLoginStatus.data.member_id" class="f15">会员可见</span>
                              <template v-else>
                                <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                                <span
                                  class="float-load"
                                  :class="isNaN(item.jiage)?'f15':'f18'"
                                  v-html="item.jiage"
                                ></span>
                              </template>
                               <cart-btn
                                  class="fr"
                                  :btn-type="getGoodsType(item)"
                                  @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                                </cart-btn>
                            </div>
                            <span class="del-price js-pei_song_jia" v-if="item.userid == 1">
                              <del v-if="!isNaN(item.shanchu_price)">
                                ￥
                                <span class="float-load" v-html="item.shanchu_price"></span>
                              </del>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </xpt-block>
                <!-- 今日特价结束 -->
                <!-- 促销套餐开始 -->
                <xpt-block
                  :more-style="{ color: '#C83ECF'}"
                  v-if="promotion.length"
                  more="/#/promotionlist"
                >
                  <div slot="title" class="tc">
                    <img style="top: 0;" src="./../../assets/img/home/left fish@2x.png" alt />
                    <img src="./../../assets/img/home/cuxiaotaocan@2x.png" alt />
                    <img src="./../../assets/img/home/right fish@2x.png" style="width: .13rem" alt />
                  </div>
                  <div class="xpt-chuxiao" v-for="(item, index) in promotion" :key="index">
                    <div class="countdown-time-box">
                      <img
                        style="width: .14rem"
                        v-lazy="'/picture/app/home/naozhong@2x.png'"
                        alt
                        srcset
                      />
                      <span>距结束：</span>
                      <div class="inline _time" data-lave="false" data-long="true">
                      <b>{{item.countDown.d}}</b>
                        <span>天</span>
                      <b>{{item.countDown.h}}</b>
                        <span>时</span>
                      <b>{{item.countDown.m}}</b>
                        <span>分</span>
                      <b>{{item.countDown.s}}</b>
                        <span>秒</span>
                      </div>
                    </div>
                    <div class="xpt-product__warpper">
                      <a class="inline100" style="overflow: hidden">
                        <div
                          style="padding-left: .07rem;padding-top:0;"
                          class="xpt-product flex-r"
                          v-for="(good, index) in showpromotion"
                          :key="index"
                        >
                          <div class="xpt-product__img promotionImg">
                            <img v-lazy="good.image" alt />
                            <div
                              v-if="isemptystock == 0 && good.stock == 0 && getLoginStatus.data.member_id"
                              class="sellOut"
                            >缺货</div>
                            <!-- <i
                        class="understock"
                            ></i>-->
                          </div>
                          <div
                            class="xpt-product__right"
                            :style="{'borderBottom':showpromotion.length!==index+1?'1px solid #EEEEEE':'none','padding':showpromotion.length!==index+1?'0 0.1rem 0.1rem 0':'0 0.1rem 0rem 0','margin-bottom':'.1rem'}"
                          >
                            <div class="xpt-product__title ell2" style="margin-bottom: .03rem;">
                              <span class="mr5">{{good.general_name}}</span>
                              <span>{{ good.norms}}</span>
                            </div>
                            <div
                              class="xpt-product__line"
                              v-if="good.showproduce_unit"
                              v-html="good.produce_unit"
                            ></div>
                            <div
                              class="xpt-product__line"
                              v-if="good.showbatch_code "
                              v-html="'批号：' + good.batch_code"
                            ></div>
                            <div
                              class="xpt-product__line"
                              v-if="good.showsource_area"
                              v-html="'原产地：' + good.source_area"
                            ></div>
                            <div class="xpt-product__line">
                              数量：
                              <span v-html="good.quantity"></span>
                              <span v-html="good.unit"></span>
                            </div>
                            <div
                              class="xpt-product__line flex-r js-pei_song_jia"
                              style="padding-top: .04rem;color:#333;font-size:0.15rem;"
                            >
                              <span class="f12" v-if="!isNaN(good.price)">￥</span>
                              <span class="float-load" v-html="good.price"></span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div class="seeMore" v-if="promotion[0].goods_list.length>2">
                      <div>
                        <p @click="seeMore()">
                          <span
                            v-if="!switchPromotion"
                          >{{'套餐共'+promotion[0].goods_list.length+'种商品，查看更多'}}</span>
                          <span v-else>收起</span>
                          <cc-svg-icon
                            :icon-class="!switchPromotion?'down-arrow':'up-arrow'"
                            class-name="down-arrow"
                            size=".2rem"
                          ></cc-svg-icon>
                        </p>
                      </div>
                    </div>
                    <div class="xpt-chuxiao__prices flex-r">
                      <div>
                        <strong class="f12 pl10 c33 fwb">套装价格：</strong>
                        <span class="curr-price js-pei_song_jia red">
                          <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                          <span
                            class="float-load"
                            :class="isNaN(item.jiage)?'f15':'f18'"
                            v-html="item.jiage"
                          ></span>
                        </span>
                        <del v-if="item.userid == 1&&!isNaN(item.shanchu_price)" class="f12 ml5">
                          <span class="js-pei_song_jia float-load" v-html="'￥'+item.shanchu_price"></span>
                        </del>
                      </div>
                      <div class="flex-1 xpt-product__tips" style="text-align: left;">
                        <!-- 区别是否已登录 -->
                        <!-- getLoadSettingStatus.data.is_delivery_flag === 1 -->
                        <a
                          class="fr"
                          :class="getLoadSettingStatus.data.is_delivery_flag? 'panicBuy':''"
                          @click="nowBuy()"
                        >立即抢购</a>
                      </div>
                    </div>
                  </div>
                </xpt-block>
                <!-- 促销套餐结束 -->
                <!-- banner图开始 -->
              <div class="adBannersSwiper" v-if="adBanners.length">
                <swiper ref="mySwiper" :options="adBannersSwiper">
                  <swiper-slide v-for="(item,index) in adBanners" :key="index">
                    <a :href="item.url==''?'javascript:void(0);':item.url">
                      <img :src="item.image" />
                    </a>
                  </swiper-slide>
                  <div style="bottom:8px;" class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
              <!-- banner图结束 -->
              <!-- 采满有赠开始 -->
              <xpt-block :more-style="{color: '#F55113'}" v-if="gift.length" more="/#/gifts">
                <div slot="title" class="tc">
                  <img style="top: 0;width: .1rem;" src="./../../assets/img/home/left3@2x.png" alt />
                  <img src="./../../assets/img/home/caimanyouzeng@2x.png" alt />
                  <img style="top: 0;width: .1rem;" src="./../../assets/img/home/right3@2x.png" alt />
                </div>
                <div class="xpt-product__warpper xpt-gifts">
                  <div class="xpt-products flex-r">
                    <div
                      class="xpt-product__vertical flex-r inline100"
                      v-for="(item, index) in gift"
                      :key="index"
                    >
                      <!-- 倒计时 -->
                      <div class="countDown">
                        <p>剩</p>
                        <p v-if="+item.countDown.d">{{item.countDown.d+'天'}}</p>
                        <p v-else>{{item.countDown.h+':'+item.countDown.m+':'+item.countDown.s}}</p>
                        </div>
                        <div class="xpt-product__desc" @click="to(item)">
                          <div class="xpt-product__img h88">
                            <img v-lazy="item.image" alt />
                            <div
                              v-if="getGoodsType(item)===2"
                              class="sellOut"
                            >缺货</div>
                          </div>
                          <div class="xpt-product__desc">
                            <div class="xpt-product__title">
                              <span class="mr5">{{item.general_name}}</span>
                              <span>{{item.norms}}</span>
                            </div>
                            <div v-if="item.showproduce_unit" class="xpt-product__line">
                              <span class="ell1" v-html="item.produce_unit"></span>
                            </div>
                            <div v-if="item.showbatch_code" class="xpt-product__line">
                              <span class="ell1" v-html="item.batch_code"></span>
                            </div>
                            <div v-if="item.showsource_area" class="xpt-product__line">
                              <span class="ell1" v-html="item.source_area"></span>
                            </div>
                          </div>
                        </div>
                        <div class="xpt-product__line">
                          <div class="xpt-product__price flex-c">
                            <div class="curr-price">
                               <span
                                v-if="getLoginStatus.data.member_id===0"
                                class="js-pei_song_jia f15"
                              >会员可见</span>
                              <span
                                v-else-if="item.is_bargain === 1 && item.tag === 2"
                                class="js-pei_song_jia f15"
                              >议价商品</span>
                              <span v-else class="js-pei_song_jia">
                                <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                                <span :class="isNaN(item.jiage)?'f15':'f18'" v-html="item.jiage"></span>
                              </span>
                              <div class="fr">
                                <cart-btn
                                  :btn-type="getGoodsType(item)"
                                  @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                                </cart-btn>
                              </div>
                            </div>
                          </div>
                          <!-- 采满有赠 活动内容 -->
                          <div style="margin: 0 0 0.04rem 0;" class="xpt-product__line js-act_hide">
                            <span
                              class="ell"
                              style="color: #999999; font-size: .1rem;"
                              v-html="item.gifts_sends_content.toString(',')"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </xpt-block>
                <!-- 采满有赠结束 -->
                <!-- 活动专区开始 -->
                <xpt-block
                  :more-style="{color: '#A99FFA'}"
                  v-if="activity.length"
                  more="/#/activity"
                >
                  <div slot="title" class="tc">
                    <img style="width: .23rem" src="./../../assets/img/home/left round@2x.png" alt />
                    <img src="./../../assets/img/home/huodongzhuanqu@2x.png" alt />
                    <img style="width: .23rem" src="./../../assets/img/home/right round@2x.png" alt />
                  </div>
                  <div class="xpt-product__warpper xpt-activity">
                    <div class="xpt-products flex-r">
                      <div
                        class="xpt-product__vertical flex-r inline100"
                        v-for="(item, index) in activity"
                        :key="index"
                      >
                        <div class="xpt-product__desc" @click="to(item)">
                          <div class="xpt-product__img h88">
                            <img v-lazy="item.image" alt />
                            <div
                              v-if="getGoodsType(item)===2"
                              class="sellOut"
                            >缺货</div>
                          </div>
                          <div class="xpt-product__desc">
                            <div class="xpt-product__title">
                              <span class="mr5">{{item.general_name}}</span>
                              <span>{{item.norms}}</span>
                            </div>
                            <div v-if="item.showproduce_unit" class="xpt-product__line">
                              <span class="ell1" v-html="item.produce_unit"></span>
                            </div>
                            <div v-if="item.showbatch_code" class="xpt-product__line">
                              <span class="ell1" v-html="item.batch_code"></span>
                            </div>
                            <div v-if="item.showsource_area" class="xpt-product__line">
                              <span class="ell1" v-html="item.source_area"></span>
                            </div>
                          </div>
                        </div>
                        <div class="xpt-product__line">
                          <div class="xpt-product__price flex-c">
                            <div class="curr-price js-pei_song_jia">
                              <span
                                v-if="item.is_bargain === 1 && item.tag === 2"
                                class="js-pei_song_jia f15"
                              >议价商品</span>
                              <span v-else>
                                <span v-if="!isNaN(item.jiage)" class="f12">￥</span>
                                <span :class="isNaN(item.jiage)?'f15':'f18'" v-html="item.jiage"></span>
                              </span>
                              <div class="fr">
                                <cart-btn
                                  :btn-type="getGoodsType(item)"
                                  @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                                </cart-btn>
                              </div>
                            </div>
                          </div>
                          <!-- 活动专区 活动内容 -->
                          <div style="margin: 0 0 0.04rem 0;" class="xpt-product__line js-act_hide">
                            <span
                              class="ell"
                              style="color: #999999; font-size: .1rem;"
                              v-html="item.activity_content"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </xpt-block>
                <!-- 活动专区结束 -->
                <!-- 为你推荐开始 -->
                <xpt-block v-if="recommendData.length">
                  <div slot="title" class="tc">
                    <img style="top: 0;width: .16rem" src="./../../assets/img/home/left@2x.png" alt />
                    <img src="./../../assets/img/home/tuijian@2x.png" alt />
                    <img style="width: .16rem;" src="./../../assets/img/home/right@2x.png" alt />
                  </div>
                  <div class="xpt-recommend" ref="recommend" v-if="recommendData.length">
                    <van-list
                      v-model="m_loading"
                      :finished="m_finished"
                      :finished-text="m_finishedText"
                      @load="mHandlePullUpLoadMore"
                      :immediate-check="m_immediateCheck"
                      class="xpt-recommend__products"
                    >
                      <div
                        class="xpt-product flex-r"
                        v-for="(item, index) in recommendData"
                        :key="index"
                      >
                        <div @click="to(item)">
                          <div class="xpt-product__img">
                            <img v-lazy="item.image" alt />
                            <div v-if="getGoodsType(item)===2" class="sellOut">缺货</div>
                            <!-- 预售的标识 -->
                            <div v-if="item.type==8" class="preSellSign">预售</div>
                            <!-- 活动标识 -->
                            <i
                              class="xpt-icons"
                              :class="{
                                'xpt-icons__manzeng': item.type == 5,
                                'xpt-icons__huodong': item.type == 4,
                                'xpt-icons__cuxiao': item.type == 3 && !item.is_bargain,
                                'xpt-icons__tejia': item.type == 2 && +item.is_seckill ===0,
                                'xpt-icons__miaosha': item.type == 2 && +item.is_seckill ===1,
                              }"
                            ></i>
                            <!--  全场促销-->
                            <i class="qccx_img" v-if="item.is_enjoy_promotion == 1"></i>
                          </div>
                        </div>
                        <div class="xpt-product__right xpt-product__desc" style="margin:0;">
                          <div @click="to(item)">
                            <div class="xpt-product__title flex-r">
                              <div class="flex-1">
                                <span class="mr5">{{item.general_name}}</span>
                                <span>{{item.norms}}</span>
                              </div>
                            </div>
                            <div class="xpt-product__line" v-if="item.showproduce_unit">
                              <span class="ell1">{{item.produce_unit}}</span>
                            </div>
                            <div class="xpt-product__line" v-if="item.showbatch_code">
                              <span class="ell1" v-html="'批号：' + item.batch_code"></span>
                            </div>
                            <div class="xpt-product__line" v-if="item.showsource_area">
                              <span class="ell1" v-html="'产地：' + item.source_area"></span>
                            </div>
                            <div
                              class="xpt-product__price flex-c"
                              style="margin-top:.08rem;margin-bottom:0"
                            >
                              <div class="curr-price">
                                <div style="display: inline-block;" class="js-pei_song_jia">
                                  <span
                                    v-if="getLoginStatus.data.member_id===0"
                                    class="js-pei_song_jia f15"
                                  >会员可见</span>
                                  <span
                                    v-else-if="item.is_bargain === 1 && item.tag === 2 && +item.type !== 8"
                                    class="js-pei_song_jia f15"
                                  >议价商品</span>
                                  <template v-else>
                                    <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                                    <span
                                      :class="isNaN(item.jiage)?'f15':'f18'"
                                      v-html="item.jiage"
                                    ></span>
                                  </template>
                                </div>
                                <del class="del-price" v-if="item.type == 2">
                                  ￥
                                  <span v-html="item.shanchu_price" class="js-pei_song_jia"></span>
                                </del>
                                <!-- 购物车 -->
                                <!-- 是否显示多批号？ 0 不显示 非0 显示 -->
                                <div class="fr">
                                  <cart-btn
                                    :btn-type="getGoodsType(item)"
                                    @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                                  </cart-btn>
                                </div>
                              </div>
                            </div>
                            <!--  折后价：未登录显示会员可见，登录后显示折后价，返回赠品折后价隐藏，区域经销显示区域经销，议价商品显示议价商品-->
                            <div
                              class="xpt-product__line ell1"
                              style="margin-bottom:0.03rem"
                              v-if="item.discount_prices && getLoginStatus.data.member_id===0"
                              v-html="'会员可见'"
                            ></div>
                            <template v-else>
                               <div
                                class="xpt-product__line ell1"
                                style="margin-bottom:0.03rem"
                                v-if="item.discount_prices && item.discount_prices !=='赠品'"
                                v-html="['区域经销','会员可见'].indexOf(item.discount_prices) !== -1  ? item.discount_prices : item.is_bargain && item.tag == 2? '议价商品':('折后价：￥'  +item.discount_prices)"
                              ></div>
                            </template>
                          </div>
                          <!-- 显示商品标签 -->
                          <div
                            v-if="item.tag_arr.length"
                            class="xpt-product__line flex-r"
                            style="margin-top: 0.01rem;margin-bottom: 0.05rem;"
                          >
                            <div v-for="(tag, index) in item.tag_arr" :key="index">
                              <div
                                :style="{'borderColor':tag.color,'color':tag.color}"
                                class="xpt-tag"
                                v-if="index < 3"
                                v-html="tag.name"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </van-list>
                  </div>
                </xpt-block>
                <!-- 为你推荐结束 -->
              <!-- </div> -->
            </div>
          </cc-main>
          <!-- 返回顶部 -->
          <div @click="backTop" class="back-top" v-if="backtopshow">
            <img src="./../../assets/img/home/top.png" alt />
          </div>
          <!-- <div @click="backRecommend" class="back-recommend" v-if="backrecommendshow">
            <img src="./../../assets/img/home/xiala.png" alt />
          </div> -->
          <!-- 活动提醒窗开始 -->
          <van-popup v-model="activityshow" class="pup_activey">
            <div class="pup_title">
              <i
                v-if="alertActivity.image"
                :style="{'background':'url('+alertActivity.image+')', backgroundSize:'cover'}"
              ></i>
              {{alertActivity.title}}
            </div>
            <div class="pup_center">{{alertActivity.content}}</div>
            <div class="pup_footer">
              <p class="btn_l" @click="suspense()">暂不关注</p>
              <p class="btn_r" @click="receive(alertActivity.url)">前往领取</p>
            </div>
          </van-popup>
          <!-- 活动提醒窗结束 -->
        </cc-container>
      </cc-pull-refresh>
      <!-- </van-pull-refresh> -->
    </div>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
    <!-- 促销套餐立即抢购购物车弹窗start -->
    <cc-promot-cart
      :isShowPopup="showCartPromot"
      :promotCartData="promotCartData"
      :height="556"
      @close="showCartPromot=false"
      v-if="showCartPromot"
    ></cc-promot-cart>
    <!-- 促销套餐立即抢购购物车弹窗end -->
  </cc-container>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Vue from 'vue'
import {
  Swipe,
  SwipeItem,
  Lazyload,
  List,
  Toast,
  Popup,
  Dialog,
  PullRefresh
} from 'vant'
import { mapActions } from 'vuex'
import { scrollTop, JsonP, getcookie } from '~utils'
import { scanning } from '~utils/xcode.js'
import ListMixin from '@/mixins/list'
import Command from '@/mixins/command'
import cartStep from '@/mixins/cartStep'
import CartBtn from './components/cart-btn.vue'
import CountDownMixin from '~mixins/countDown'


import {
  loadIndex,
  loadNews,
  activityIndexshow,
  sp,
  tuiJian,
  activity
} from '../../fetch/home/index.js'
import xptBlock from './xptblock.vue'
import Skeleton from './skeleton.vue'
Vue.use(PullRefresh)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(List)
  .use(Toast)
  .use(Popup)
  .use(Dialog)
export default {
  name: 'Home',
  mixins: [ListMixin, Command, cartStep, CountDownMixin],
  components: {
    xptBlock,
    Skeleton,
    swiper,
    swiperSlide,
    CartBtn
  },
  data () {
    return {
      // 促销套餐数据
      promotCartData: '',
      // 立即抢购加入购物车开关
      showCartPromot: false,
      // 弹窗活动提醒开关
      activityshow: false,
      // 骨架屏的显示和隐藏
      showSkeleton: true,
      // 轮播图的data
      swipelist: [],
      // 各个模块的data
      column: [],
      // 新闻data
      notificationList: [],
      // 新闻下方的data
      activityindexshow: [],
      // 限时秒杀data
      seckillList: [],
      // 限时秒杀倒计时
      seckillTime: {},
      // 秒杀几场开始
      seckillStar: '',
      // 今日特价data
      special: [],
      // 促销套餐data
      promotion: [],
      // 是否开启0库存购买
      isemptystock: '',
      // banner图数据
      adBanners: [],
      // 采满有赠data
      gift: [],
      // 活动专区data
      activity: [],
      // 为你推荐data
      recommendData: [],
      // 滚动向上图标开关
      backtopshow: false,
      // 滚动向下图标开关
      // backrecommendshow: false,
      // 多批号的值
      // product: {},
      not_show_field_arr: [],
      // 活动弹窗数据
      alertActivity: '',
      // 判断促销套餐data显示完全的开关
      switchPromotion: false,
      // 下拉刷新开关
      isLoading: false,
      disabled: false,
      swipernav: {
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  watch: {},
  computed: {
    // 对促销套餐data进行数据处理
    showpromotion () {
      var arr = []
      arr = !this.switchPromotion
        ? this.promotion[0].goods_list.filter((item, index) => {
          return index <= 1
        })
        : this.promotion[0].goods_list
      return arr
    },
    swiper () {
      if (this.$refs.mySwiper) {
        return this.$refs.mySwiper.swiper
      } else {
        return false
      }
    },
    // 轮播图数据
    barnnswiper () {
      if (this.swipelist.length) {
        if (this.swipelist.length === 1) {
          var obj1 = {
            pagination: {
              el: '.swiper-pagination'
            }
          }
          return obj1
        } else {
          var obj2 = {
            pagination: {
              el: '.swiper-pagination'
            },
            autoplay: true, // 可设置数值来指定播放速度
            speed: 400, // 切换图片速度
            loop: true
          }
          return obj2
        }
      } else {
        return false
      }
    },
    adBannersSwiper () {
      if (this.adBanners.length) {
        if (this.adBanners.length === 1) {
          var obj1 = {
            pagination: {
              el: '.swiper-pagination'
            }
          }
          return obj1
        } else {
          var obj2 = {
            pagination: {
              el: '.swiper-pagination'
            },
            autoplay: true, // 可设置数值来指定播放速度
            speed: 400, // 切换图片速度
            loop: true
          }
          return obj2
        }
      } else {
        return false
      }
    }
  },

  async created () {
    await Promise.all([this.loadActivey(), this.loadData()])
  },

  mounted () {
    // 轮播图
    if (this.swiper !== false || this.swiper) {
      this.swiper.slideTo(1, 1000, true)
    }

    setTimeout(() => {
      this.scrollAndref()
    }, 2000)
    // JsonP('http://pv.sohu.com/cityjson?ie=utf-8')
    /* eslint no-undef: 'off' */
    setTimeout(async () => {
      var returnCitySN = JSON.parse(sessionStorage.getItem('returnCitySN'))
      if (returnCitySN) {
        var cityIndex = returnCitySN.city.indexOf('市');
        var dialogCity = returnCitySN.city.substring(returnCitySN.city, cityIndex);
        // console.log(dialogCity,111);

        let res = await activity({ city: dialogCity })

        this.alertActivity = res.data
        if (res.data.length === 0) {
          return
        }
        var newTime = Math.round(new Date().getTime())
        // 获取一个cookie
        var val = parseInt(getcookie('oldTime'))
        var total = (newTime - val) / 1000
        var day = parseInt(total / (24 * 60 * 60))
        if (!isNaN(val)) {
          if (day >= res.interval) {
            this.activityshow = true
          } else {
            this.activityshow = false
          }
        } else {
          this.activityshow = true
        }
      }
    }, 2000)
  },
  methods: {
    ...mapActions(['LOAD_SETTING_DATA', 'IS_LOGIN']),
    judgeTime (item) {
      return parseInt(+item.end_date - +item.now_time)
    },
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) {
        if (item.is_view === 1) {
          return 1 // 区域经销
        } else if (item.type === 8) {
          // 预售商品
          return +item.presell_stock === 0 ? 2 : 0
        } else {
          // 议价商品
          if (+item.is_bargain === 1 && item.tag === 2) {
            return 1
          } else if (item.for_type === 1 || item.for_type === 4) {
            // 普通商品and满赠商品
            if (+item.goodsstock === 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) {
              return 2
            } else {
              return 0
            }
          } else if (item.for_type === 2) {
            if (+item.stock === 0) {
              return 3
            } else if (+item.goodsstock === 0) {
              return 2
            }
          } else {
            if (+item.goodsstock === 0) {
              return 2
            } else {
              return 0
            }
          }
        }
      } else {
        return 0
      }
    },
    /**
     * 滚动到顶部加刷新
     */
    scrollAndref () {
      if (this.$refs.main) {
        this.$refs.main.$el.onscroll = e => {
          if (e.target.scrollTop > 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
        this.$refs.main.$el.addEventListener('scroll', this.scrollEvent, true)
      }
    },
    /**
     * 刷新
     */
    onRefresh () {
      // this.showSkeleton = true
      setTimeout(async () => {
        // this.$toast('刷新成功')
        // this.swipelist = []
        // this.column = []
        // this.notificationList = []
        // this.activityindexshow = []
        // this.promotion = []
        // this.adBanners = []
        // this.gift = []
        // this.activity = []
        // this.recommendData = []
        // this.special = []
        await Promise.all([this.loadActivey(), this.searchData()])
        this.scrollAndref()
        this.getSetting()
      }, 500)
    },
    /**
     * 扫一扫
     */
    openScanning () {
      scanning(this)
    },
    /**
     * 促销套餐查看更多
     */
    seeMore () {
      this.switchPromotion = !this.switchPromotion
    },
    onClose () {},
    // 点击购物车购买
    cartBtn (item, cartColor) {
      this.cartBtnAlter(item, cartColor)
    },
    /**
     * 添加时间属性
     */
    assignmentTime (item, nowTime) {
      item.now_time = nowTime
      this.$set(item, 'countDown', {
        d: '',
        h: '',
        m: '',
        s: ''
      })
      this.countDown(item)
    },
    async loadActivey () {
      await Promise.all([
        loadIndex(),
        loadNews(),
        activityIndexshow({ showad: 1 }),
        sp()
      ]).then(values => {
        // ====刷新时的数据====
        this.swipelist = []
        this.column = []
        this.notificationList = []
        this.activityindexshow = []
        this.promotion = []
        this.adBanners = []
        this.gift = []
        this.activity = []
        // this.recommendData = []
        this.special = []
        this.showSkeleton = false
        this.swipelist = values[0].data.ad
        //= =========== 对各个模块数据进行处理start===========
        var newcolumn = values[0].data.topmenu
        var line = Math.ceil(newcolumn.length / 10)
        var count = 0
        for (var i = 0; i < line; i++) {
          let newline = newcolumn.slice(count, count + 10)
          count = count + 10
          this.column.push(newline)
        }
        // this.$set(item, 'price', '配送价')
        // this.$set(this.column, 'this.column', 'this.column')
        //= =========== 对各个模块数据进行处理end===========
        this.notificationList = values[1].data.news_list
        this.activityindexshow = values[2].data.activity_show
        // ===========各专区数据==============
        // 今日特价data
        this.not_show_field_arr = values[3].data.not_show_field_arr
        this.special = values[3].data.total_activitys.special
        // 限时秒杀
        this.seckillList = values[3].data.total_activitys.seckill
        // 限时秒杀倒计时
        values[3].data.seckill_select_time.end_date =
          values[3].data.seckill_select_time.end_time
        this.assignmentTime(
          values[3].data.seckill_select_time,
          values[3].data.now_time
        )
        this.seckillTime = values[3].data.seckill_select_time
        this.seckillStar = values[3].data.seckill_select_time.select_time
        // 对数据字段进行处理
        this.addGoodField(this.special)
        this.special.forEach(item => {
          this.assignmentTime(item, values[3].data.now_time)
        })
        // 限时秒杀
        this.addGoodField(this.seckillList)
        // 促销数据data
        values[3].data.total_activitys.promotion.map(item => {
          this.assignmentTime(item, values[3].data.now_time)
        })
        this.promotion = values[3].data.total_activitys.promotion
        this.addGoodField(this.promotion)
        if (this.promotion[0]) {
          this.promotion[0].goods_list.forEach(item => {
            if (this.getLoadSettingStatus.data.is_delivery_flag === 1) {
              this.$set(item, 'price', '配送价')
            }
            item.price = isNaN(item.price)
              ? item.price
              : this.float_change(item.price)
          })
        }
        this.isemptystock = values[3].data.isemptystock
        this.adBanners = values[3].data.adbanner_image_list
        // 采满有赠data
        this.gift = values[3].data.total_activitys.gift
        this.addGoodField(this.gift)
        this.gift.forEach(item => {
          this.assignmentTime(item, values[3].data.now_time)
        })
        // 活动专区data
        this.activity = values[3].data.total_activitys.activity
        this.addGoodField(this.activity)
      })
    },
    searchData () {
      this.recommendData = []
      this.isLoading = false
      this.m_page.curr = 1
      this.loadData()
    },
    async loadData () {
      // 为你推荐data
      this.mRequest()
      var params = {
        page: this.m_page.curr,
        limit: this.m_page.limit
      }
      let res = await tuiJian(params)
      this.not_show_field_arr = res.data.not_show_field_arr
      if (res.data.tuijian_goods_arr.length === 0) {
        // 全部数据加载完成
        this.m_finishedText = '-- 我也是有底线的 --'
        this.mEnd()
      } else {
        let arr = this.addGoodField(res.data.tuijian_goods_arr)
        this.recommendData = [...this.recommendData, ...arr]
        if (res.data.tuijian_goods_arr.length < 10) {
          this.m_finishedText = '-- 我也是有底线的 --'
          this.mEnd()
        }
      }
      this.mSuccess()
    },
    /**
     * @description 返回顶部
     */
    scrollEvent () {
      var scrollTop = this.$refs.main.$el.scrollTop
      // if (scrollTop > 10) {
      //   // 向下箭头
      //   this.backrecommendshow = true
      // } else if (scrollTop <= 10) {
      //   this.backrecommendshow = false
      // }
      // if (scrollTop >= 2100) {
      //   this.backrecommendshow = false
      //   this.backtopshow = true
      // } else {
      //   // 向上箭头
      //   this.backtopshow = false
      // }
      this.backtopshow = scrollTop >= 1500
    },
    /**
     * @description 返回顶部(向上走)
     */
    backTop () {
      scrollTop(this.$refs.main)
    },
    /**
     * @description 返回顶部(向下走)
     */
    // backRecommend () {
    //   scrollBottom(this.$refs.main)
    // },
    /**
     * @description goto详情页
     */
    to (item) {
      if (typeof item === 'object') {
        // window.location = item.goods_id
        //   ? '/product/detail?id=' + item.goods_id + '&type=1'
        //   : '/product/detail?id=' + item.id + '&type=1'
        this.$router.push({
          path: '/goods-details',
          query: {
            goods_id: item.goods_id ? item.goods_id : item.id,
            type: item.type
          }
        })
      } else {
        item ? (window.location = item) : (window.location = `/#/home`)
      }
    },
    /**
     * @description 促销套餐立即抢购
     */
    nowBuy () {
      if (this.getLoginStatus.data.member_id === 0) {
        location.href = '/visitor/login'
      } else {
        if (this.getLoadSettingStatus.data.is_delivery_flag === 1) {
          Toast('委托配送商品不参与促销套装')
          return false
        }
        this.showCartPromot = true
        this.promotCartData = {
          ...this.promotion[0],
          choose: 0,
          num: 1,
          step: 1
        }
        this.promotCartData.stock = +this.promotCartData.stock
      }
    },
    /**
     * @description 活动提醒的前往领取
     */
    receive (url) {
      window.location.href = url
    },
    /**
     * @description 活动提醒的暂不关注
     */
    suspense () {
      this.activityshow = false
      var oldTime = Math.round(new Date().getTime())
      // 创建一个cookie
      document.cookie = 'oldTime=' + oldTime + ' expires=99 path=/'
    }
  },
  activated () {
    // 退出登录时，需重新更新全局的登录状态
    if (this.$route.query.signout) {
      this.IS_LOGIN()
    }
    if (sessionStorage.getItem('scrollHome') && this.$refs.main) {
      this.$refs.main.$el.scrollTop = sessionStorage.getItem('scrollHome')
    }
  },
  deactivated () {
    sessionStorage.setItem('scrollHome', this.$refs.main.$el.scrollTop)
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.main{
  height: calc(100% - 50px);
}
.home {
  .swipe {
    width: 100%;
    height: 140px;
    text-align: center;
    a,
    img {
      display: inline-block;
      height: 140px;
      width: 355px;
      border-radius: 15px;
    }
  }
  .c-column {
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    padding: 5px 0;
    margin:5px 10px 0 10px;
    border-radius: 4px 4px 0 0;
    a {
      width: 20%;
      height: 70px;
      float: left;
      color: #626262;
      font-size: 12px;
    }
    span {
      width: 40px;
      height: 40px;
      display: inline-block;
      background: url("./../../assets/img/home/img.png") no-repeat;
      background-size: 40px 480px;
    }
    // 首页图标精灵图图标的位置
    .pro-cate {
      background-position: 0 -40px;
    }
    .special {
      background-position: 0 -200px;
    }
    .combo {
      background-position: 0 -280px;
    }
    .AdoptFull {
      background-position: 0 -320px;
    }
    .points {
      background-position: 0 -120px;
    }
    .coupon {
      background-position: 0 -160px;
    }
    .Speedy {
      background-position: 0 -240px;
    }
    .controlPpin {
      background-position: 0 -360px;
    }
    .history {
      background-position: 0 -80px;
    }
    .presell {
      background-position: 0 -400px;
    }
    .seckill {
      background-position: 0 -440px;
    }
    p {
      line-height: 18px;
      font-size: 12px;
    }
  }
  .xpt-notification {
    background: #fff;
    border-radius: 0 0 4px 4px;
    height: 0.4rem;
    line-height: 0.35rem;
    padding: 5px 20px;
    box-sizing: border-box;
    margin: 0 10px 10px 10px;
    // margin: 10px;
    li {
      @include ell();
      margin-right: 8px;
    }
  }
  .xpt-notification__left {
    padding-right: 10px;
    font-weight: 400;
  }
  .xpt-notification__right {
    margin-left: 5px;
    font-size: 12px;
    color: #838383;
  }
  .xpt-recommend .xpt-product__right {
    padding: 0px 10px 10px 15px;
    width: 245px;
  }
  .xpt-recommend {
    .xpt-product__line {
      display: flex;
      align-items: center;
      min-height: 14px;
    }
  }
  .xpt-notification__right .xpt-notification__titles {
    height: 0.3rem;
    overflow: hidden;
    position: relative;
    line-height: 0.3rem;
    text-align: left;
    color: #333;
    font-size: 0.12rem;
  }
  .xpt-notification__right span.fr {
    line-height: 0.3rem;
    font-size: 0.12rem;
  }
  .xpt-notification__right .xpt-notification__titles::after {
    content: " ";
    position: absolute;
    top: 0.1rem;
    right: 0.05rem;
    width: 0.01rem;
    height: 0.11rem;
    background: #e2e1e1;
  }
  #cart_loading {
    background: #fff;
    margin: 0.05rem 0.1rem;
    border-radius: 4px;
    padding: 0.1rem;
  }
  .image-text-area {
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 0.1rem 0 0.1rem;
  }
  .image-text-area li {
    float: left;
    width: 172.5px;
    height: 70px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }
  .image-text-area li:nth-child(odd) {
    margin-right: 10px;
  }
  .image-text-area li .image-text {
    display: block;
    height: 100%;
  }
  .image-text-area li .image-text img {
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
.promotionImg {
  width: 90px;
  height: 70px;
  position: relative;
  img {
    border-radius: 4px;
  }
}
.xpt-product__img > img {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 4px;
}
.xpt-product {
  background: #fff;
  margin-bottom: 2px;
  position: relative;
  padding-top: 15px;
}
.xpt-block__body {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
.xpt-product__right {
  margin-left: 20px;
  padding-bottom: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 60%;
}
.xpt-product__title {
  font-size: 0.15rem;
  color: #333;
  line-height: 0.18rem;
  min-height: 0.18rem;
  width: 100%;
  @include ell();
  margin-bottom: 3px;
}
.ell2 {
  @include ell(2);
}
.xpt-product__warpper {
  position: relative;
  border-radius: 4px 4px 0 0;
  -webkit-overflow-scrolling: touch;
}
.seeMore {
  height: 40px;
  color: #777777;
  font-size: 12px;
  background: #fff;

  div {
    border-top: 1px solid #eeeeee;
    margin: 0 10px;
    height: 40px;
    @include center();
  }
}
.xpt-product__warpper .xpt-products {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  overflow-y: auto;
  background-color: #fff;
}
.xpt-product__vertical {
  display: inline-block;
  background-color: #fff;
  min-width: 40%;
  width: 40%;
  text-align: center;
  padding: 0 14.5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  border-right: 1px solid #f2f2f2;
}
.xpt-product__vertical .xpt-product__img {
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  width: 100%;
}
//限时秒杀图片大小
.h88 {
  height: 88px;
}
// 倒计时
.countDown {
  width: 100%;
  margin: 10px 0;
  text-align: center;
  font-size: 10px;
  p {
    display: inline-block;
    text-align: center;
    border: 1px solid #f00a19;
    height: 16px;
    line-height: 16px;
  }
  p:nth-child(1) {
    width: 22.5px;
    background: #f00a19;
    border-radius: 10px 0 0px 10px;
    color: #ffffff;
    vertical-align: middle;
  }
  p:nth-child(2) {
    width: 56px;
    border-radius: 0 10px 10px 0;
    color: #f00a19;
    vertical-align: middle;
  }
}
.xpt-product__line {
  font-size: 0.12rem;
  margin-bottom: 0.03rem;
  text-overflow: ellipsis;
  // white-space: nowrap;
  overflow: hidden;
  min-height: 0.14rem;
  color: #777;
  text-align: left;
}
.ell1 {
  @include ell();
}
.xpt-product__desc .xpt-product__line:last-child {
  margin-bottom: 0;
}
.xpt-product__desc {
  font-size: 12px;
  color: #666;
  margin: 10px 0 3px 0;
  max-height: 100%;
  min-height: 14px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-orient: vertical;
}
.xpt-product__desc {
  text-align: left;
  overflow: hidden;
}
.curr-price {
  color: #ea2727;
  font-size: 0.18rem;
  line-height: 22px;
}
.del-price {
  height: 18px;
  color: #999;
  font-size: 12px;
  font-weight: 400;
}
.xpt-product__price {
  min-height: 0.22rem;
  margin-bottom: 0.03rem;
}
.iconfont::before,
body #content .iconfont.qh::before {
  color: #bfbfbf;
}
body #content .iconfont::before {
  color: #6398ff;
}
/*限时秒杀样式开始*/
.being-mad-at {
  font-size: 0.12rem;
  color: #ed4f6a;
  margin-right: 10px;
}
.xpt-seckill-end {
  font-size: 12px;
  color: #777777;
  margin-right: -8px;
}
.progress-bg {
  width: 60px;
  height: 5px;
  background-color: #ffe5ec;
  border-radius: 25px;
  margin-bottom: 10px;
  overflow: hidden;
}
.xpt-seckill-num {
  height: 100%;
  background-color: #eb1515;
}
.xpt-seckill-progress {
  font-size: 12px;
  color: #777;
}
.xpt-seckill-robbed {
  /deep/ {
    font-size: 12px !important;
    color: #999999;
    // padding-left: 8px;
    transform: scale(0.9);
    margin-top: -5px;
  }
}
.xpt-miaosha-seckill {
  b {
    color: #ec4070 !important;
  }
}
.inline {
  b {
    border-radius: 2px;
  }
}
/*=============限时秒杀样式结束============*/
/* ============促销套餐样式开始============ */
.xpt-chuxiao {
  position: relative;
}
.xpt-chuxiao ul {
  -webkit-overflow-scrolling: touch;
}
.xpt-chuxiao .xpt-product__warpper {
  overflow-y: scroll;
  background: #fff;
}
.xpt-chuxiao .xpt-product__vertical:last-child {
  margin-right: 0;
}
.xpt-chuxiao__prices {
  padding-left: 5px;
  margin-top: 2px;
  font-size: 16px;
  line-height: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 0 0 4px 4px;

  a {
    display: inline-block;
    background: var(--APP_theme_color);
    width: 65px;
    height: 26px;
    color: #fff;
    border: 0;
    font-size: 12px;
    @include center();
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 8px;
    margin-right: 10px;
    border-radius: 13px;
  }
  .panicBuy {
    background: #b1b1b1;
  }
}
.countdown-time-box {
  text-align: center;
  background: #fff;
  font-size: 0.12rem;
  padding: 0.15rem 0;
}
.countdown-time-box img:nth-child(1) {
  margin-right: 0.07rem;
  position: relative;
  top: 0.02rem;
}
.countdown-time-box b {
  display: inline-block;
  padding: 0 0.02rem;
  margin: 0 0.06rem;
  color: #eb2626;
  font-weight: bold;
  border: 1px solid #e5e5e5;
}
.inline {
  display: inline-block;
}
/* ==================促销套餐样式结束=============== */
/* ==================为你推荐样式开始=============== */
.xpt-recommend__products .xpt-product {
  padding-left: 0.1rem;
}
// 无货
.out-of-stock > img {
  position: absolute;
  right: 0;
  bottom: 0;
}
.xpt-recommend__products .xpt-product__img {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}
/*=================== 为你推荐样式结束============= */
.iconfont[data-v-5b685826]::before,
body #content .iconfont.qh[data-v-5b685826]::before {
  color: #6398ff;
}
//nogoods 弹窗
.popup-nogoods {
  width: 100%;
  height: 100%;
  .popup-title {
    width: 100%;
    height: 20%;
    background: #2e97ff;
    color: #fff;
    font-size: 14px;
    @include center();
  }
  .popup-conter {
    height: 50%;
    @include center();
    flex-wrap: wrap;
  }
  .popup-remed {
    font-size: 14px;
    border: 1px solid #dcdcdc;
    width: 60%;
    height: 40%;
    @include center();
  }
  .active {
    border: 2px solid #e9630a !important;
  }
  .popup-input {
    display: inline-block;
    height: 100%;
    border: 0;
  }
  .popup-btn {
    height: 30%;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid #dcdcdc;
    p {
      height: 100%;
      width: 50%;
      @include center();
    }
    .cancel {
      color: #333;
    }
    .submit {
      background: #2e97ff;
      color: #fff;
    }
  }
}
.pup_activey {
  width: 100%;
  height: 25%;
  border-radius: 3px;
  font-size: 14px;
  .pup_title {
    width: 100%;
    height: 20%;
    font-size: 14px;
    @include center();
    border-bottom: 1px solid #ddd;
    position: relative;
    i {
      position: absolute;
      top: 10px;
      display: inline-block;
      left: 10px;
      width: 20px;
      height: 20px;
      background-size: cover;
    }
  }
  .pup_center,
  .pup_footer {
    background: #fafafa;
    width: 100%;
  }
  .pup_center {
    height: 50%;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .pup_footer {
    height: 30%;
    box-sizing: border-box;
    padding: 0 40px;
    display: flex;

    p {
      display: inline-block;
      height: 34px;
      width: 40%;
      border-radius: 3px;
      @include center();
      box-sizing: border-box;
    }
    .btn_l {
      border: 1px solid #0c9cf3;
      margin-right: 20%;
    }
    .btn_r {
      background: #0c9cf3;
      color: #fff;
    }
  }
  .flex-c {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}
// 修改轮播图的样式
.swiper-wrapper {
  /deep/ {
    .van-swipe__indicator {
      width: 13px;
      height: 3px;
    }
  }
}
// 渐变弯角样式
.gradualChange {
  height: 83px;
  width: 100%;
  position: absolute;
  border-radius: 0px 0px 15px 15px;
  background: linear-gradient(
    to right,
    var(--APP_theme_color),
    var(--APP_theme_color_colorOpacity5)
  );
}
// 修改轮播图样式
.c-column,
.swiper-wrapper {
  /deep/ {
    .van-swipe__indicator {
      width: 13px;
      height: 3px;
      background: #777777;
      border-radius: 0;
    }
    .van-swipe__indicator--active {
      background: var(--APP_theme_color) !important;
    }
  }
}
// .c-column {
//   /deep/ {
//     .van-swipe__indicators {
//       bottom: 0;
//       i {
//         border-radius: 40%;
//       }
//     }
//   }
// }
.pull-refresh {
  height: 100%;
  /deep/ {
    > div {
      height: 100%;
    }
  }
}
/deep/.van-pull-refresh {
  overflow: auto !important;
}
.swipe{
  /deep/{
     .swiper-pagination-bullet-active{
      background: #fff;
    }
  }
}
// 轮播图样式
.c-column ,.adBannersSwiper{
  /deep/ {
    .swiper-container {
      padding-bottom: 0.05rem;
    }
    .swiper-pagination-bullet {
      border-radius: 20%;
      width: 0.13rem;
      height: 0.03rem;
      display: inline-block;
    }
    .swiper-pagination-bullet-active{
      background: var(--APP_theme_color) !important;
    }
  }
}
.c-column {
  /deep/{
    .swiper-container{
      margin: 0 0.1rem 0rem 0.1rem;
    }
    // .swiper-pagination-fraction,
    // .swiper-pagination-custom,
    // .swiper-container-horizontal > .swiper-pagination-bullets {
    //   bottom: 0px !important;
    // }
  }
}
.xpt-miaosha .xpt-product__line,
.xpt-special .xpt-product__line,
.xpt-gifts .xpt-product__line,
.xpt-activity .xpt-product__line {
  line-height: 14px;
}
.adBannersSwiper{
  height: 82px;
  width:355px;
  margin:0 10px 10px 10px;
  border-radius: 10px;
  overflow: hidden;
  a,img{
    display: inline-block;
    height: 82px;
    width:355px;
  }
}
</style>
